import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import { BackPage, Forms } from 'components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {useExemption, useQuery} from 'hooks';

const ExemptionsPage = () => {
  let query = useQuery();
  const [getExemption,,]=useExemption();
  const history = useHistory();
  const startedJourney = useSelector((state) => state.paymentJourney.started);
  const accountView = query.get('view') === 'account' ? true : false;
  const [accountExemption, setAccountExemption] = useState({});

  useEffect(() => {
    if (!accountView && !startedJourney) history.push('/pharmacy/dashboard');
    const getExemptionDetail = async () => {
      const exemption = await getExemption();
      setAccountExemption(exemption);
    }
    getExemptionDetail();

  }, [history, startedJourney, accountView]);

  return (
    <BackPage
      onBackClick={() => (accountView ? history.goBack() : history.push('/pharmacy/dashboard/delivery-options'))}>
      <h1 className={styles.header}>{!accountView ? 'Do you pay for your prescriptions?' : 'Exemption'}</h1>
      {!accountView && <p>If you have a pre-payment certificate, select ‘No’.</p>}
      <Forms.ExemptionForm accountView={accountView} accountExemption={accountExemption} />
    </BackPage>
  );
};

export default ExemptionsPage;
